import _ from '../../core/utils'

const JOBS_CONFIG = {
    section: _.select( '.section--jobs-content' ),
    jobs: _.selectAll( '.section--jobs-content .job' ),
    loader: _.select( '.section--jobs-content .jobs__more' )
}

export default JOBS_CONFIG